var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternIllustrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 48,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#755CDE",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32h4v4h-4zM46 32h4v4h-4zM60 32h4v4h-4zM32 46h4v4h-4zM46 46h4v4h-4zM60 46h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 60h4v4h-4zM46 60h4v4h-4zM60 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F39E9E",
    d: "m0 32 32 32V32z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32h4v4h-4zM46 32h4v4h-4zM60 32h4v4h-4zM32 56h4v4h-4zM46 56h4v4h-4zM60 56h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 60h4v4h-4zM46 60h4v4h-4zM60 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0h4v4h-4zM46 0h4v4h-4zM60 0h4v4h-4zM32 4h4v4h-4zM46 4h4v4h-4zM60 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 28h4v4h-4zM46 28h4v4h-4zM60 28h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#61C4B7",
    d: "m0 32 32 32V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "M32 0 0 32V0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternIllustrations);
export default __webpack_public_path__ + "static/media/pattern-illustrations.14f5b1d2c7935111bba9043f4cf2051e.svg";
export { ForwardRef as ReactComponent };